export default "__VITE_ASSET__bl2vEuTR__"